import Cookies from 'js-cookie';

import {
  BOOK_QUERY_SUCCESS,
} from '../constants/actions';

function bookQuerySuccess(data) {
  return {
    type: BOOK_QUERY_SUCCESS,
    payload: {
      data,
    },
  };
}

export function clearBookQuery() {
  return async (dispatch) => {
    // clear in cookie
    Cookies.remove('mhub-book-web-book-queries');
    // clear in state
    await dispatch(bookQuerySuccess([]));
  };
}

export function extractBookQuery(props) {
  return (dispatch) => {
    const queries = [];
    // extract from cookie
    const cQueries = Cookies.getJSON('mhub-book-web-book-queries');
    if (cQueries) {
      cQueries.forEach((cq) => {
        if (!queries.find(q => q.name === cq.name)) {
          queries.push(cq);
        }
      });
    }
    // extract from URL query
    if (props.location && props.location.query) {
      const { query } = props.location;
      Object.keys(query).forEach((q) => {
        if (q.startsWith('book_')) {
          const eIndex = queries.findIndex(dq => dq.name === q);
          if (eIndex > -1) {
            // replace new query value
            queries[eIndex].value = query[q];
          } else {
            // add new query
            queries.push({
              name: q,
              value: query[q],
            });
          }
        }
      });
    }
    // save to cookie
    Cookies.set('mhub-book-web-book-queries', queries, { expires: 1 });
    // save to state
    dispatch(bookQuerySuccess(queries));
  };
}



// WEBPACK FOOTER //
// ./src/actions/bookQuery.js